module.exports = __webpack_public_path__ + "static/media/sustainability_m.5f3dd99d.mp4";